// Mirrors backend api/models.py::RESERVED_ROLE_IDS — role_ids the backend
// permission layer checks by literal string. These roles cannot be deleted,
// cannot be renamed (role_id), and cannot be previewed via the role preview
// feature. Must stay in sync with the backend constant.
export const RESERVED_ROLE_IDS = ['security', 'admin']
